module.exports = __webpack_public_path__ + "img/prince-akachi-J1OScm_uHUQ-unsplash.ebad8975.jpg";